import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  // ✅ Always works: direct Render (doesn't rely on Vercel rewrites)
  const API_BASE = useMemo(() => {
    const raw = (process.env.REACT_APP_API_URL || "").trim();
    const cleaned = raw.replace(/\/$/, "").replace(/\/api$/, ""); // prevent .../api/api
    return cleaned || "https://streamsite-v8dd.onrender.com";
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSent(false);
    setSubmitting(true);

    try {
      const normalized = (email || "").trim().toLowerCase();

      const res = await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: normalized }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data?.error || "Could not send reset email.");
      }

      setSent(true);
    } catch (err) {
      setError(err?.message || "Could not send reset email.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Forgot password</h1>
        <p style={styles.subtitle}>
          Enter your account email and we’ll send a reset link.
        </p>

        {error ? <div style={styles.error}>{error}</div> : null}
        {sent ? (
          <div style={styles.success}>
            If that email exists, we sent a reset link. Check your inbox (and spam).
          </div>
        ) : null}

        <form onSubmit={handleSubmit} style={{ display: "grid", gap: 12, marginTop: 12 }}>
          <label style={styles.label}>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
              required
              style={styles.input}
            />
          </label>

          <button type="submit" disabled={submitting} style={styles.primaryBtn}>
            {submitting ? "Sending..." : "Send reset link"}
          </button>

          <div style={{ marginTop: 4 }}>
            <Link to="/signin" style={styles.link}>Back to Sign in</Link>
          </div>
        </form>
      </div>
    </section>
  );
};

const styles = {
  page: { minHeight: "calc(100vh - 90px)", display: "grid", placeItems: "center", padding: "24px 16px" },
  card: {
    width: "min(640px, 92vw)",
    background: "rgba(0,0,0,0.62)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 16,
    padding: 20,
    boxShadow: "0 16px 40px rgba(0,0,0,0.55)",
    backdropFilter: "blur(10px)",
  },
  title: { margin: 0, fontSize: 34, letterSpacing: 0.2 },
  subtitle: { margin: "8px 0 0 0", opacity: 0.85, lineHeight: 1.35 },
  label: { display: "grid", gap: 6, fontSize: 14, opacity: 0.95 },
  input: {
    width: "100%",
    padding: "12px 12px",
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.16)",
    background: "rgba(255,255,255,0.06)",
    color: "white",
    outline: "none",
  },
  primaryBtn: { padding: "12px 14px", borderRadius: 12, border: "none", cursor: "pointer", fontWeight: 800 },
  link: { color: "#7cc7ff", textDecoration: "none", fontSize: 14 },
  error: {
    marginTop: 12,
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px solid rgba(255,80,80,0.35)",
    background: "rgba(255,80,80,0.12)",
    color: "white",
  },
  success: {
    marginTop: 12,
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px solid rgba(120,255,160,0.25)",
    background: "rgba(120,255,160,0.10)",
    color: "white",
  },
};

export default ForgotPassword;
